import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "reminder_active",
  "use": "reminder_active-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"reminder_active\"><path d=\"M10.131 18a3.001 3.001 0 0 1-2.828-2h5.657a3.001 3.001 0 0 1-2.829 2ZM4 15a1 1 0 0 1-.832-1.555L4.13 12V8a6 6 0 1 1 12 0v4l.964 1.445A1 1 0 0 1 16.263 15H4Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol